import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import DAProtect from '@wix/da-ds/pkg/Indicators/DAProtect';
import SophisticatedTooltipLink from '@wix/da-ds/pkg/tooltips/SophisticatedTooltipLink';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { URLS } from '@wix/da-url';
import SophisticatedTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SophisticatedTooltip';
import s from './DAProtectIconWithTooltip.scss';
const DAProtectIconWithTooltip = (_param)=>{
    var { variant, withLabel = false } = _param, rest = _object_without_properties(_param, [
        "variant",
        "withLabel"
    ]);
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    return /*#__PURE__*/ React.createElement(SophisticatedTooltip, {
        size: "medium",
        "aria-label": t(`daProtect.tooltip.ariaLabel`),
        description: t(`daProtect.tooltip.var.${variant}`),
        hasCloseButton: false,
        postfix: variant === 'active' ? /*#__PURE__*/ React.createElement(SophisticatedTooltipLink, {
            href: "https://www.deviantartsupport.com/en/article/what-is-deviantart-protect"
        }, t('daProtect.tooltip.learnMore')) : /*#__PURE__*/ React.createElement(SophisticatedTooltipLink, {
            href: URLS.CORE_MEMBERSHIP,
            biData: {
                evid: BiEventType.BUY_CORE_BUTTON,
                referral_info: variant === 'inactive' ? ReferralType.DAPROTECT_OFF : ReferralType.DAPROTECT_TEMP
            }
        }, t('daProtect.tooltip.upgrade'))
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(DAProtect, _object_spread({
        variant: variant
    }, rest)), withLabel && /*#__PURE__*/ React.createElement("span", {
        className: s['label']
    }, isMobile && t(`daProtect.label.mobile.var.${variant}`), !isMobile && t(`daProtect.label.desktop.var.${variant}`))));
};
DAProtectIconWithTooltip.displayName = 'DAProtectIconWithTooltip';
export default DAProtectIconWithTooltip;
